import { useLocation } from 'react-router';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import posthog from 'posthog-js';
import { getAppConfig } from 'app/getConfig';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FeatureFlags } from 'config/featureFlags';
import { selectCurrentCompanyName } from 'reduxStore/project/projectSelector';

import { useIdentifyPostHog } from './useIdentifyPostHog';

export const useInitializePostHog = () => {
  const { REACT_APP_PUBLIC_POSTHOG_KEY, REACT_APP_PUBLIC_POSTHOG_HOST } = getAppConfig();
  const location = useLocation();
  const isPosthogEnabled = useFeatureIsOn(FeatureFlags.POSTHOG_CORE);
  const companyName = useSelector(selectCurrentCompanyName);
  const posthogInitedRef = useRef(false);

  if (
    !posthogInitedRef.current &&
    REACT_APP_PUBLIC_POSTHOG_KEY &&
    REACT_APP_PUBLIC_POSTHOG_HOST &&
    isPosthogEnabled
  ) {
    posthog.init(REACT_APP_PUBLIC_POSTHOG_KEY, {
      api_host: REACT_APP_PUBLIC_POSTHOG_HOST,
      loaded: (posthog) => {
        if (process.env.NODE_ENV === 'development') posthog.debug();
      },
    });

    posthogInitedRef.current = true;
  }

  useIdentifyPostHog();

  useEffect(() => {
    if (isPosthogEnabled) {
      posthog.capture('$pageview');
    }
  }, [location.pathname, isPosthogEnabled]);

  useEffect(() => {
    if (isPosthogEnabled && companyName) {
      posthog.capture('company_name_changed', { companyName });
    }
  }, [companyName, isPosthogEnabled]);
};
